var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg83(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6,
    height: 11,
    viewBox: "0 0 6 11",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.55693 5.35273C5.55693 5.46523 5.51943 5.55898 5.44443 5.65273L1.20693 9.96523C1.03818 10.134 0.775684 10.134 0.606934 9.96523C0.438184 9.79648 0.438184 9.53398 0.606934 9.36523L4.52568 5.35273L0.569433 1.34023C0.400683 1.17148 0.400683 0.908984 0.569433 0.740234C0.738183 0.571485 1.00068 0.571485 1.16943 0.740234L5.40693 5.05273C5.50068 5.14648 5.55693 5.24023 5.55693 5.35273Z",
    fill: "#4F81BD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg83);
export default __webpack_public_path__ + "static/media/svg83.368d0b57ef38ce321cb7ec04b9262a09.svg";
export { ForwardRef as ReactComponent };